let BASE_URL = "https://dev.skillsbridge.ai/api"; // Comment this out for local testing
//let BASE_URL = "http://127.0.0.1:5000/api"; // UNCOMMENT THIS for local testing
let AUTH_BASE_URL = "https://dev.skillsbridge.ai";

if (process.env.NODE_ENV === "production") {
  BASE_URL = process.env.REACT_APP_API_BASE_URL;
  AUTH_BASE_URL = process.env.REACT_APP_AUTH_BASE_URL;
}

export const API_ENDPOINTS = {

  UX_FEEDBACK: `${BASE_URL}/add_organization_feedback`,
  USER_ANALYTICS: `${BASE_URL}/user_analytics`,

  JOBS_VIEW: `${BASE_URL}/jobcode_view`,
  RNC_JOBS_VIEW: `${BASE_URL}/rnc_jobcode_view`,
  REQUISITION_VIEW: `${BASE_URL}/requisition_view`,
  RNC_REQUISITION_VIEW: `${BASE_URL}/rnc_requisition_view`,
  UPDATE_COMMENT: `${BASE_URL}/update_comment`,
  VERSIONS: `${BASE_URL}/versions`,
  RNC_VERSIONS: `${BASE_URL}/rnc_versions`,
  //SB_JOB_DESCRIPTION: `${BASE_URL}/sb_job_description`,
  SB_JOB_DESCRIPTION: `${BASE_URL}/status_based_job_description`,
  ORIGINAL_JOB_DESCRIPTION: `${BASE_URL}/base_job_description`,
  //ORIGINAL_JOB_DESCRIPTION: `${BASE_URL}/original_job_description`,

  AUTOMATION_POTENTIAL: `${BASE_URL}/automation_potential`,
  COMPARE_DATA: `${BASE_URL}/compare_data`,
  COMPARE_JOBS: `${BASE_URL}/compare_jobs`,
  ERROR_MESSAGE: `${BASE_URL}/error_message`,
  UPLOAD: `${BASE_URL}/upload`,
  UPLOAD_INSERT: `${BASE_URL}/upload_insert`,
  CREATE_REVISE_JD_PROGRESS: `${BASE_URL}/task/initiate_revise_jd_workflow`,
  ANALYZE_JD: `${BASE_URL}/analyze_jd`,
  GET_UPLOADED_FILE: `${BASE_URL}/get_uploaded_file`,
  READ_FROM_BIGQUERY: `${BASE_URL}/bq/read`,
  UPDATE_BIGQUERY: `${BASE_URL}/bq/update`,
  INSERT_BIGQUERY: `${BASE_URL}/bq/insert`,
  CREATE_VERSION: `${BASE_URL}/create_version`,
  INTERVIEW_QUESTIONS: `${BASE_URL}/interview_questions`,
  CREATE_JD: `${BASE_URL}/create_jd`,
  CREATE_JD_PROGRESS: `${BASE_URL}/task/initiate_create_jd_workflow`,
  CREATE_JD_INSERT: `${BASE_URL}/create_jd_insert`,
  ADD_JOB_CODE: `${BASE_URL}/add_job_code`, //job code

  AUTHENICATION: `${AUTH_BASE_URL}/auth/api/auth/login`,
  LOGOUT: `${AUTH_BASE_URL}/auth/api/auth/logout`,
  PROTECTED: `${BASE_URL}/user/view`,
  ENTITLEMENT: `${AUTH_BASE_URL}/auth/api/role/entitlements`,

  REGISTER_TEMP_USER: `${AUTH_BASE_URL}/auth/api/user/register-temp-user`,
  CREATE_NEW_USER: `${AUTH_BASE_URL}/auth/api/user/create-new-user `,
  FORGOT_PASSWORD: `${AUTH_BASE_URL}/auth/api/user/forgot-password`,

  VERIFY_OTP_SIGNUP: `${AUTH_BASE_URL}/auth/api/user/invitation`,
  VERIFY_OTP_FORGOT: `${AUTH_BASE_URL}/auth/api/user/forgot-password/validate/otp`,

  RESEND_OTP_SIGNUP: `${AUTH_BASE_URL}/auth/api/user/invitation`,
  RESEND_OTP_FORGOT: `${AUTH_BASE_URL}/auth/api/user/forgot-password/resend/otp`,
  SET_PASSWORD: `${AUTH_BASE_URL}/auth/api/user/set-password`,

  RE_AUTHORISE_TOKEN: `${AUTH_BASE_URL}/auth/api/auth/refresh`,


  FETCH_ROLES: `${BASE_URL}/roles`,
  //FETCH_OG_JD_EVAL: `${BASE_URL}/original_jd_eval_score`,
  FETCH_OG_JD_EVAL: `${BASE_URL}/base_jd_eval_score`,

  FETCH_SB_JD_EVAL: `${BASE_URL}/generated_jd_eval_score`,
  FETCH_ORG_METADATA: `${AUTH_BASE_URL}/auth/api/organization/metadata`,
  FETCH_ORG_DOMAINS: (orgId) => `${AUTH_BASE_URL}/auth/api/organization/${orgId}/domains`,
  FETCH_ORG_STRUCTURE: `${BASE_URL}/structure/complete`,
  SAFETYCHECK: `${BASE_URL}/safety/skillsbridger_safety_check`,
  GET_ERROR_MESSAGES: `${AUTH_BASE_URL}/auth/api/error_code/get-error-codes`,
  PUBLISH_JD: `${BASE_URL}/publish_job_description`,
  SELF_PUBLISH_JD: `${BASE_URL}/self_publish_jd`,
  UNPUBLISH_JD: `${BASE_URL}/unpublish_job_description`,
  EDIT_JD: `${BASE_URL}/edit_job_description`,
  REGENERATE_JD: `${BASE_URL}/regenerate_jd`,
  RETRY_JD_GENERATION: `${BASE_URL}/retry_jd_generation`,
  UPDATE_CRITICAL_ROLE: `${BASE_URL}/mark_critical_role`,

  EMPLOYEE_VIEW: `${BASE_URL}/skillsbridger/employee_view`,
  EMPLOYEE_JD_SKILL_ANALYSIS: `${BASE_URL}/skillsbridger/employee_jd_skill_analysis`,
  EMPLOYEE_ADDITIONAL_SKILLS: `${BASE_URL}/skillsbridger/employee_additional_skills`,
  EMPLOYEE_UPLOADS: `${BASE_URL}/skillsbridger/employee_uploads`,
  EMPLOYEE_UPLOAD_DELETE: `${BASE_URL}/skillsbridger/employee_uploads/delete`,
  EMPLOYEE_PROFICIENCY_CHANGE_REASONS: `${BASE_URL}/skillsbridger/employee_selfreportedproficiency`,
  EMPLOYEE_GET_FILES: `${BASE_URL}/skillsbridger/get-files`,
  EMPLOYEE_GET_FILE_CONTENT: `${BASE_URL}/skillsbridger/get-file-details-by-file-id`,
  EMPLOYEE_SCALE_DEFINITION: `${BASE_URL}/skillsbridger/skill_proficiency_scale_definition`,
  EMPLOYEE_FILE_SAVE: `${BASE_URL}/skillsbridger/employee_uploads_save_reinfer`,
  EMPLOYEE_SUBMIT: `${BASE_URL}/skillsbridger/skill_agree_and_submit`,


  // JD ownership: delegation (Ownership design, part 2)
  OWNERSHIP_DELEGATE: `${BASE_URL}/ownership/delegate`,
  OWNERSHIP_DELEGATE_CANDIDATES: `${BASE_URL}/ownership/delegate_candidates`,
  OWNERSHIP_SHARE: `${BASE_URL}/ownership/share`,
  OWNERSHIP_SHARE_CANDIDATES: `${BASE_URL}/ownership/share_candidates`,
  DRAFT_DIFF: `${BASE_URL}/approval/draft_diff`,
  DRAFT_FEEDBACK: `${BASE_URL}/draft_feedback`,
  JD_DOWNLOADED: `${BASE_URL}/jd_downloaded`,
  OWNERSHIP_ADMIN_JOBS_LIBRARY: `${BASE_URL}/ownership/admin/jobs_library`,
  OWNERSHIP_ADMIN_PAIC: `${BASE_URL}/ownership/admin/paic`,
  OWNERSHIP_TRANSFER: `${BASE_URL}/ownership/transfer`,
  OWNERSHIP_TRANSFER_CANDIDATES: `${BASE_URL}/ownership/transfer_candidates`,
  OWNERSHIP_REASSIGN_APPROVER: `${BASE_URL}/ownership/reassign_approver`,
  OWNERSHIP_REASSIGN_CANDIDATES: `${BASE_URL}/ownership/reassign_candidates`,

  // Approval Workflow
  APPROVAL_CANDIDATES: `${BASE_URL}/approval/candidates`,
  APPROVAL_SUBMIT: `${BASE_URL}/approval/submit`,
  APPROVAL_DIFF: `${BASE_URL}/approval/diff`,
  APPROVAL_REVIEW: `${BASE_URL}/approval/review`,
  APPROVAL_DASHBOARD: `${BASE_URL}/approval/dashboard`,
  APPROVAL_HISTORY_LIST: `${BASE_URL}/approval/history_list`,
  APPROVAL_COMPARE_CUSTOM: `${BASE_URL}/approval/compare_custom`,
  APPROVAL_REVISION_CONTEXT: `${BASE_URL}/approval/revision_context`,
  APPROVAL_COMPARE_MARKDOWNS: `${BASE_URL}/approval/compare_markdowns`,
  APPROVAL_SAVE_REVISION: `${BASE_URL}/approval/save_revision`,
  PERSISTENT_NOTIFICATIONS: `${BASE_URL}/notifications/persistent`,
  CLEAR_ALL_PERSISTENT: `${BASE_URL}/notifications/persistent`,
  CLEAR_SPECIFIC_PERSISTENT: `${BASE_URL}/notifications/persistent/clear_item`,

  // MongoDB
  GET_FULL_JOB_DETAIL: `${BASE_URL}/sb_mongo/get_full_job_detail`,

  //RabbitMQ
  GET_NOTIFICATIONS: `${BASE_URL}/notifications`,
  RAPPID_MQ_EVENTS: `${BASE_URL}/event/events/`,   // legacy — V1 SbJobsLibrary
  EVENT_STREAM: `${BASE_URL}/event/stream`,         // V2 multi-stream SSE
  NOTIFICATION_STREAM: `${BASE_URL}/event/notification-stream`, // V2 notification-only SSE
  SSO_LOGIN_EXCHANGE: `${AUTH_BASE_URL}/auth/saml/exchange`,
  SSO_LOGIN: `${AUTH_BASE_URL}/auth/saml/login`,

  // Notification pending after login
  GET_ALL_NOTIFICATIONS: `${AUTH_BASE_URL}/auth/api/notification/all `,
  DELETE_ALL_NOTIFICATIONS: `${AUTH_BASE_URL}/auth/api/notification/clear `,

  // Profile
  GET_PROFILES: `${AUTH_BASE_URL}/auth/api/role/profile`,
  CREATE_NEW_PROFILE: `${AUTH_BASE_URL}/auth/api/role/create-role`,
  GET_ROLE_WITH_ENTITLEMENTS: `${AUTH_BASE_URL}/auth/api`,
  GET_FEATURE_WISE_ENTITLEMENT_LIST: `${AUTH_BASE_URL}/auth/api/entitlement/feature`,
  UPDATE_ROLE_WITH_ENTITLEMENTS: `${AUTH_BASE_URL}/auth/api`,
  GET_VERSION_SOURCE: `${AUTH_BASE_URL}/auth/api/version/info`,

  //PAIC
  PAIC_INFERRED_JDS: `${BASE_URL}/paic/requisition_view`,
  PAIC_GET_ORG_PROJECTS: `${BASE_URL}/paic/get_org_projects`,
  PAIC_GET_ORG_PROJECT_WITH_ID: `${BASE_URL}/paic/get_org_project`,
  PAIC_CREATE_ORG_PROJECT: `${BASE_URL}/paic/create_project`,
  PAIC_CREATE_PROJECT_RUN: `${BASE_URL}/paic/create_project_run`,
  PAIC_PROJECT_STATUS: `${BASE_URL}/paic/project/status`,
  PAIC_GET_AGENTS: `${BASE_URL}/paic/get_agents`,
  PAIC_GET_ALL_AGENTS: `${BASE_URL}/paic/get_all_agents`,
  PAIC_GET_AGENTS_BY_ROLES: `${BASE_URL}/paic/get_agents_by_roles`,
  PAIC_SELECTED_AGENTS_STATS: `${BASE_URL}/paic/agent_total`,
  PAIC_GET_AGENT_SELECTIONS: `${BASE_URL}/paic/get_agent_selections`,
  PAIC_INSERT_SELECTED_AGENTS: `${BASE_URL}/paic/insert_selected_agents`,
  PAIC_RESUBMIT_SELECTION: `${BASE_URL}/paic/resubmit_selection`,
  PAIC_GET_AGENT_PRD: `${BASE_URL}/paic/get_agent_prd`,
  PAIC_GET_AGENT_PRD_VERSIONS: `${BASE_URL}/paic/get_agent_prd_versions`,
  PAIC_SAVE_AGENT_PRD: `${BASE_URL}/paic/save_agent_prd`,
  PAIC_GET_AGENT_JD: `${BASE_URL}/paic/get_agent_jd`,
  PAIC_GET_PAIC_JD: `${BASE_URL}/paic/get_paic_jds`,
  PAIC_GET_AGENT_DETAILS: `${BASE_URL}/paic/get_agent`,
  PAIC_GET_ROLE_IMPACT: `${BASE_URL}/paic/get_role_impact`,
  PAIC_UPDATE_AGENT: `${BASE_URL}/paic/update_agent`,
  PAIC_REINITIATE_PROJECT_RUN: `${BASE_URL}/paic/reinitate_project_run`,
  PAIC_UPDATE_ARCHIVE_STATUS: `${BASE_URL}/paic/update_archive_status`,
  PAIC_DELEGATE_PROJECT: `${BASE_URL}/paic/delegate_project`,
  PAIC_SHARE_PROJECT: `${BASE_URL}/paic/share_project`,
  PAIC_TRANSFER_PROJECT_OWNER: `${BASE_URL}/paic/transfer_project_owner`,
  PAIC_TRANSFER_PROJECTS: `${BASE_URL}/paic/transfer_projects`,

  // Org Redesign (Org Design module — org_redesign_bp)
  ORG_REDESIGN_CURRENT_ORG_STRUCTURE: `${BASE_URL}/organization-redesign/current-org-structure`,
  ORG_REDESIGN_ORGANIZATION_VIEW: `${BASE_URL}/organization-redesign/organization-view`,
  ORG_REDESIGN_PAIC_PROJECTS: `${BASE_URL}/organization-redesign/paic-projects`,
  ORG_REDESIGN_PAIC_PROJECT_HANDSHAKE: `${BASE_URL}/organization-redesign/paic-projects`,
  ORG_REDESIGN_PAIC_PROJECT_VERSIONS: `${BASE_URL}/organization-redesign/paic-project`,
  ORG_REDESIGN_CREATE_VERSION: `${BASE_URL}/organization-redesign/create-org-redesign-version`,
  ORG_REDESIGN_VERSION: `${BASE_URL}/organization-redesign/version`,
  ORG_REDESIGN_VERSIONS: `${BASE_URL}/organization-redesign/versions`,
  ORG_REDESIGN_CURRENT_ORG_BUDGET: `${BASE_URL}/organization-redesign/current-org-budget`,

  // Org Context
  ORG_CONTEXT_TOOL_CATALOG: `${BASE_URL}/org-context/tool-catalog`,
  ORG_CONTEXT_TOOLS_SELECTION: `${BASE_URL}/org-context/org-tools-selection`,
  ORG_CONTEXT_ADMIN_SETUP: `${BASE_URL}/org-context/admin-setup`,
  // Compensation Management
  COMP_REQUISITION_VIEW: `${BASE_URL}/organization-setup/requisition_view`,
  COMP_GET_COMPENSATION: `${BASE_URL}/organization-setup/get-compensation`,
  COMP_INSERT_COMPENSATION: `${BASE_URL}/organization-setup/insert-compensation`,
  COMP_UPDATE_COMPENSATION: `${BASE_URL}/organization-setup/update-compensation`,
  COMP_JD_IDENTIFIER_CONFIG: `${BASE_URL}/organization-setup/jd-identifier-config`,

  // Currency Settings
  COMP_CURRENCY_SETTINGS: `${BASE_URL}/organization-setup/currency-settings`,

  // Bulk Compensation Upload/Download
  COMP_DOWNLOAD_TEMPLATE: `${BASE_URL}/organization-setup/compensation/download-template`,
  COMP_BULK_UPLOAD: `${BASE_URL}/organization-setup/compensation/bulk-upload`,

  // Legal consent
  LEGAL_CONSENT: `${BASE_URL}/legal/consent`,

  // Ask Allie
  ALLIE_CHAT: `${BASE_URL}/allie/chat`,
  ALLIE_FEEDBACK: `${BASE_URL}/allie/feedback`,
  ALLIE_SESSIONS: `${BASE_URL}/allie/sessions`,

  // Employee
  GET_EMPLOYEES: `${AUTH_BASE_URL}/auth/api/employee/get-employees`,
  UPDATE_EMPLOYEE: `${AUTH_BASE_URL}/auth/api/employee`,
  MANAGER_EMPLOYEES_LISTING: `${AUTH_BASE_URL}/auth/api/employee/manager-employees-listing`,

  // System JD upload
  SYSTEM_UPLOAD_INSERT: `${BASE_URL}/system_upload_insert`,
  SYSTEM_UPLOAD: `${BASE_URL}/system_upload`,

  // Bulk Upload
  BULK_JD_DOWNLOAD_TEMPLATE: `${BASE_URL}/organization-setup/system-upload/download-template`,
  BULK_JD_UPLOAD: `${BASE_URL}/organization-setup/system-upload/bulk-upload`,

  // Role Reporting
  ROLE_REPORTING_VIEW: `${BASE_URL}/role-reporting-to/requisition_view`,
  ROLE_REPORTING_UPDATE: `${BASE_URL}/role-reporting-to/update-role-reporting-to`,
  ROLE_REPORTING_DOWNLOAD_TEMPLATE: `${BASE_URL}/role-reporting-to/download-template`,
  ROLE_REPORTING_BULK_UPLOAD: `${BASE_URL}/role-reporting-to/bulk-upload`,

  // JD Archive
  JD_ARCHIVE_UPDATE_STATUS: `${BASE_URL}/archive_jd`,

  // Organization Hierarchy
  ORG_HIERARCHY_DOWNLOAD_TEMPLATE: `${BASE_URL}/organization-setup/org-hierarchy/download-template`,
  ORG_HIERARCHY_UPLOAD: `${BASE_URL}/organization-setup/org-hierarchy/upload`,
  ORG_HIERARCHY_MAPPING_RESULTS: `${BASE_URL}/organization-setup/org-hierarchy/mapping-results`,
  ORG_HIERARCHY_CONFIRM_MAPPING: `${BASE_URL}/organization-setup/org-hierarchy/resolve-mapping`,
  ORG_HIERARCHY_EMPLOYEES: `${BASE_URL}/organization-setup/org-hierarchy/employees`,
  ORG_HIERARCHY_ONBOARD_MAPPED_EMPLOYEES: `${BASE_URL}/organization-setup/org-hierarchy/onboard-mapped-employees`,
  HRIS_STREAM: `${BASE_URL}/organization-setup/org-hierarchy/hris-stream/`, // HRIS mapping SSE stream

  // Function Access Control
  EMPLOYEE_FUNCTION_ACCESS: `${BASE_URL}/access/emp-function-access`,
  UPDATE_EMPLOYEE_ACCESS: `${BASE_URL}/access/update-emp-access`,
    //Admin setting
  GET_ALL_JD_TEMPLATES: `${BASE_URL}/jd-templates`,
  GET_JD_TEMPLATE:      `${BASE_URL}/jd-templates`,
  CREATE_JD_TEMPLATE:   `${BASE_URL}/jd-templates`,
  UPDATE_JD_TEMPLATE:   `${BASE_URL}/jd-templates`,
  GET_JD_MERGE_FIELDS:  `${BASE_URL}/jd-templates/merge-fields`,
  UPLOAD_JD_BANNER:     `${BASE_URL}/jd-templates/banner`,
  GET_JD_BANNER:        `${BASE_URL}/jd-templates/banner`,
  ORGANIZATION_STRUCTURE: `${BASE_URL}/organization-setup/structure`,
  

  ALL_EMPLOYEES:                   `${BASE_URL}/skillsbridger/hr/all_employees`,
  GROUP_JD_SKILL_ANALYSIS:         `${BASE_URL}/skillsbridger/hr/group_jd_skill_analysis`,
  GROUP_SUMMARY:                   `${BASE_URL}/skillsbridger/hr/group_summary`,
  EMPLOYEE_SUMMARY:                `${BASE_URL}/skillsbridger/hr/employee_summary`,

  // Agent Builder
  AGENT_BUILDER_START:    `${BASE_URL}/agent-builder/start`,
  AGENT_BUILDER_STREAM:   `${BASE_URL}/agent-builder/stream/`,
  AGENT_BUILDER_ANSWER:   `${BASE_URL}/agent-builder/answer/`,
  AGENT_BUILDER_STATUS:   `${BASE_URL}/agent-builder/status/`,
  AGENT_BUILDER_DOWNLOAD: `${BASE_URL}/agent-builder/download/`,

  // Talent Mobility
  TALENT_MOBILITY_THRESHOLDS: `${BASE_URL}/talent-mobility/thresholds`,
  TALENT_MOBILITY_EMPLOYEES: `${BASE_URL}/talent-mobility/employees`,
  TALENT_MOBILITY_JOB_OPENING_STATUS: `${BASE_URL}/talent-mobility/job-opening-status`,
  TALENT_MOBILITY_PEOPLE_PROFILE_DETAILS: `${BASE_URL}/talent-mobility/people-profile-details`,
  TALENT_MOBILITY_ROLE_SUCCESSOR_ANALYTICS: `${BASE_URL}/talent-mobility/role-successor-analytics`,
  TALENT_MOBILITY_EMPLOYEE_SKILLS: `${BASE_URL}/talent-mobility/employee-skills`,
  TALENT_MOBILITY_SHORTLIST: `${BASE_URL}/talent-mobility/shortlist`,
  TALENT_MOBILITY_NEXT_ROLES: `${BASE_URL}/talent-mobility/next-roles`,
  TALENT_MOBILITY_JD_ACTIVE_EMPLOYEES: `${BASE_URL}/talent-mobility/jd-active-employees`,
  TALENT_MOBILITY_REDEPLOYMENT_PLAN: `${BASE_URL}/talent-mobility/redeployment-plan`,
  TALENT_MOBILITY_REDEPLOYMENT_PLAN_DETAILS: `${BASE_URL}/talent-mobility/redeployment-plan/details`,
  TALENT_MOBILITY_WORKFORCE_PEOPLE_AVAILABILITY: `${BASE_URL}/talent-mobility/workforce-planning/people-availability`,
  TALENT_MOBILITY_WORKFORCE_PLAN: `${BASE_URL}/talent-mobility/workforce-plan`,
  TALENT_MOBILITY_WORKFORCE_PLAN_DETAILS: `${BASE_URL}/talent-mobility/workforce-plan/details`,
  TALENT_MOBILITY_PAIC_REDESIGN_PLAN: `${BASE_URL}/talent-mobility/paic-redesign-plan`,
  TALENT_MOBILITY_PAIC_REDESIGN_PLAN_DETAILS: `${BASE_URL}/talent-mobility/paic-redesign-plan/details`,
  TALENT_MOBILITY_PUBLISHED_JOBS: `${BASE_URL}/talent-mobility/published-jobs`,
  TALENT_MOBILITY_CAREER_PATHS: `${BASE_URL}/talent-mobility/career-paths`,
  TALENT_MOBILITY_CAREER_PATHS_SMI_STATUS: `${BASE_URL}/talent-mobility/career-paths/smi-status`,
  TALENT_MOBILITY_APPLY: `${BASE_URL}/talent-mobility/apply`,
  // View Planning (Talent Mobility ▸ Planning Tools ▸ View Planning)
  VIEW_PLANNING_REDEPLOYMENT_PLANS: `${BASE_URL}/talent-mobility/view-planning/redeployment-plans`,
  VIEW_PLANNING_REDEPLOYMENT_PLAN_ROLES: `${BASE_URL}/talent-mobility/view-planning/redeployment-plan/roles`,
  VIEW_PLANNING_REDEPLOYMENT_ROLE_EMPLOYEES: `${BASE_URL}/talent-mobility/view-planning/redeployment-plan/role-employees`,
  VIEW_PLANNING_WORKFORCE_PLANS: `${BASE_URL}/talent-mobility/view-planning/workforce-plans`,
  VIEW_PLANNING_WORKFORCE_PLAN_JOBS: `${BASE_URL}/talent-mobility/view-planning/workforce-plan/jobs`,
  VIEW_PLANNING_PAIC_REDESIGN_PLANS: `${BASE_URL}/talent-mobility/view-planning/paic-redesign-plans`,
  VIEW_PLANNING_PAIC_REDESIGN_PLAN_ROLES: `${BASE_URL}/talent-mobility/view-planning/paic-redesign-plan/roles`,
  VIEW_PLANNING_PAIC_REDESIGN_ROLE_EMPLOYEES: `${BASE_URL}/talent-mobility/view-planning/paic-redesign-plan/role-employees`,
  TALENT_MOBILITY_APPLICATIONS: `${BASE_URL}/talent-mobility/applications`,
  SUCCESSION_TREE_FILTERS: `${BASE_URL}/talent-mobility/succession-tree/filters`,
  SUCCESSION_TREE: `${BASE_URL}/talent-mobility/succession-tree`,

  // Work Transformation Dashboard
  WORK_TRANSFORMATION_SUMMARY: `${BASE_URL}/work-transformation/summary`,
  WORK_TRANSFORMATION_TOTAL_POTENTIAL: `${BASE_URL}/work-transformation/total-potential`,
  WORK_TRANSFORMATION_COLLABORATION: `${BASE_URL}/work-transformation/collaboration`,
  WORK_TRANSFORMATION_ROI_LEADERBOARD: `${BASE_URL}/work-transformation/roi-leaderboard`,
  WORK_TRANSFORMATION_SKILLS: `${BASE_URL}/work-transformation/skills`,
};

export const SSO_LOGIN_DOMAINS = process.env.REACT_APP_MARKETCAST_DOMAIN_URL;